<template>
    <form @submit.prevent="submitForm" class="max-w-md md:px-0 px-5 pt-10 mx-auto">
        <h1 class="flex text-2xl justify-center pt-10 mb-6">Update Profile</h1>

        <div class="relative z-0 w-full mb-5 group flex justify-center">
          <img :src="image" alt="" width="200" height="200" class="img-fluid rounded"/>
        </div>

        <div class="relative z-0 w-full mb-5 group">
          <label class="block mb-2 text-sm  font-medium text-gray-900 dark:text-white" for="file_input">Upload Image</label>
          <input
              class="block w-full text-sm text-gray-900 border px-3 md:px-0 border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
              aria-describedby="file_input_help" id="file_input" @change="imageSelected" type="file">
        </div>

        <div class="relative mt-3 z-0 w-full mb-5 group">
            <input type="text" v-model="display_name" name="name" id="name"
                class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" " required />
            <label for="floating_password"
                class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Display
                Name</label>
        </div>
        <div class="relative z-0 w-full mb-5 group">
            <input type="email" v-model="email" name="email" id="email"
                class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" " />
            <label for="floating_password"
                class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Email</label>
        </div>

        <button type="submit"
            class="text-white bg-bg-save hover:bg-hover-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
            {{ isLoading ? 'Updating' : 'Update Profile' }}

            <svg v-if="isLoading" aria-hidden="true" role="status"
              class="inline ms-2 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="#E5E7EB" />
              <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentColor" />
          </svg>
          </button>
    </form>
</template>
    
<script setup>
import { useAuthService } from '@/store/Auth'; //  auth.js file
import axiosInstance from "@/plugins/axios";
import { ref, onMounted, watch } from 'vue';
import Swal from 'sweetalert2';


const authStore = useAuthService();

const display_name = ref('');
const email = ref('');
const fileInput = ref(null);
const image = ref('');
const isLoading = ref(false);

onMounted(()=> {
  const authData = authStore.authData;
  image.value = authData.image;
  display_name.value = authData.display_name;

  if (authData.email && authData.email != null && authData.email != 'null') {
    email.value = authData.email;
  }
});

// Watch for changes in auth store data from the store
watch(
    () => authStore.authData,
    (newData) => {
      image.value = newData.image;
      display_name.value = newData.display_name;
      if (newData.email && newData.email != null && newData.email != 'null') {
        email.value = newData.email;
      }
    }
);

function imageSelected(event) {
  fileInput.value = event.target.files[0];

  if (fileInput.value) {
    const imageUrl = URL.createObjectURL(fileInput.value);
    image.value = imageUrl;
  }
}

const submitForm = async () => {
  isLoading.value = true;
  try {
    const formData = new FormData();
    formData.append('display_name', display_name.value);
    formData.append('email', email.value ?? '');
    formData.append('image', fileInput.value ?? ''); // Appending the file

    const response = await axiosInstance.post('/update-profile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    isLoading.value = false;

    authStore.authDataFunction(response.data.data)

    // Show success message or perform other actions
    Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: 'Profile updated successfully!'
    });
  } catch (error) {
    isLoading.value = false;
    // Handle errors or show error message to the user
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: error.response.data.message,
    });
  }
};
</script>